export default __webpack_public_path__ + "static/media/Background_00199.0a068a5d.png";